<template>
    <div v-if="report.inquiries != null && report.inquiries.length > 0" class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-content">
                     <div class="row p-2">
                        <div class="col-lg-4 col-xl-4 col-md-4" v-for="inquiry in report.inquiries">
                            <div class="card shadow-none bg-transparent border-success">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-9">
                                            <div>
                                                <span class="card-text mb-50 text-primary">
                                                    <strong style="font-size:14px">
                                                        Creditor:
                                                    </strong>
                                                </span>
                                                {{ inquiry.creditor_name }}
                                                <span v-if="reportStore.isNew('inquiries', inquiry)" class="ml-1 badge badge-pill badge-glow badge-down badge-primary" style="font-size:10px">
                                                    New
                                                </span>
                                            </div>
                                            <div>
                                                <span class="card-text mb-50 text-primary">
                                                    <strong style="font-size:14px">
                                                        Type Of Business:
                                                    </strong>
                                                </span>
                                                 {{ inquiry.type_of_business }}
                                            </div>
                                            <div>
                                                <span class="card-text mb-50 text-primary">
                                                    <strong style="font-size:14px">
                                                        Date Of Inquiry:
                                                    </strong>
                                                </span>
                                                 {{ inquiry.date_of_inquiry }}
                                            </div>
                                        </div>
                                        <div class="col-3 my-auto">
                                            <img v-if="inquiry.credit_bureau==='TransUnion'" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/transunion.png" alt="image" width="75" height="75">
                                            <img v-if="inquiry.credit_bureau==='Equifax'" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/equifax.png" alt="image" width="75" height="75">
                                            <img v-if="inquiry.credit_bureau==='Experian'" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/experian.png" alt="image" width="75" height="75">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="reportStore.getDeletedAccounts('inquiries').length > 0" class="col-lg-4 col-xl-4 col-md-4" v-for="inquiry in reportStore.getDeletedAccounts('inquiries')">
                            <div class="card shadow-none bg-transparent border-success">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-9">
                                            <div>
                                                <span class="card-text mb-50 text-primary">
                                                    <strong style="font-size:14px">
                                                        Creditor:
                                                    </strong>
                                                </span>
                                                {{ inquiry.creditor_name }}
                                                <span class="ml-1 badge badge-pill badge-glow badge-down badge-danger" style="font-size:10px">
                                                    Deleted
                                                </span>
                                            </div>
                                            <div>
                                                <span class="card-text mb-50 text-primary">
                                                    <strong style="font-size:14px">
                                                        Type Of Business:
                                                    </strong>
                                                </span>
                                                 {{ inquiry.type_of_business }}
                                            </div>
                                            <div>
                                                <span class="card-text mb-50 text-primary">
                                                    <strong style="font-size:14px">
                                                        Date Of Inquiry:
                                                    </strong>
                                                </span>
                                                 {{ inquiry.date_of_inquiry }}
                                            </div>
                                        </div>
                                        <div class="col-3 my-auto">
                                            <img v-if="inquiry.credit_bureau==='TransUnion'" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/transunion.png" alt="image" width="75" height="75">
                                            <img v-if="inquiry.credit_bureau==='Equifax'" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/equifax.png" alt="image" width="75" height="75">
                                            <img v-if="inquiry.credit_bureau==='Experian'" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/experian.png" alt="image" width="75" height="75">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="!reportStore.reports[email].haveReport">
        <div class="col-sm-12">
            <div class="card" :class="{ 'shadow': $route.params.client }" >
                <div class="card-body">
                    <div class="mx-auto">
                        <h3 class="text-center text-warning mb-1">Oops...Your Credit Report is Missing.</h3>
                        <h6 class=" text-center text-warning mb-2">In order view the Dispute Center, you must import your Credit Report.
                            <br> If you don't already have a credit report, you can get one by clicking the button below.
                        </h6>
                    </div>
                    <div style="text-align:center;">
                        <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                            class="btn btn-warning ">
                            <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p v-else class="text-center font-medium-3 text-bold-600 warning">You don't have any Report Data.</p>
</template>

<script>
    import { reactive, computed } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    export default {
        mounted() {
        },
        props: {
            email: String
        },
        setup(props) {
            return {
                localizationStore: useLocalizationStore(),
                reportStore: useReportStore(),
                report: useReportStore().reports[props.email].report
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>
